import { usePrivacyAndSecurityStatusQuery } from "modules/PrivacyAndSecurityDashboard/hooks";

import type { User } from "models";

export const useIsUserDPOAndMustSign = (user?: User) => {
  const { data: privacyAndSecurityStatus } = usePrivacyAndSecurityStatusQuery(user?.dpo ? user.dealer_id : undefined);

  return privacyAndSecurityStatus?.signed === false && privacyAndSecurityStatus.data_officer.id === user?.id;
};
